var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { DropDownListWrapper } from "../DropDownListWrapper";
import { Arrow } from "../Arrow";
import { DropDownController } from "./DropDownController";
import { observer } from "mobx-react";
let DropDown = class DropDown extends React.Component {
    constructor(props) {
        super(props);
        this.html = {
            filter: React.createRef(),
            rootElement: React.createRef()
        };
        this.controller = new DropDownController({
            data: props.data,
            hasFilter: !!props.hasFilter,
            filterNoResults: props.filterNoResults,
            onChangeCallback: props.onChangeCallback,
            onShowOptionsCallback: props.onShowOptionsCallback,
            onHideOptionsCallback: props.onHideOptionsCallback,
            showPlaceHolder: !!props.showPlaceHolder,
            html: this.html
        });
    }
    componentDidMount() {
        this.controller.activate();
    }
    componentWillUnmount() {
        this.controller.deactivate();
    }
    render() {
        return (React.createElement("div", { className: this.getRootClasses(), ref: this.html.rootElement },
            this.props.hasFilter ? this.renderFilter() : this.renderNativeSelect(),
            React.createElement("div", { className: "rj-drop-down__value-container" },
                this.renderValue(),
                React.createElement(Arrow, { direction: this.controller.isOpened ? "up" : "down" })),
            this.controller.isOpened && this.renderDropDownList()));
    }
    renderValue() {
        let props = {
            className: "rj-drop-down__value",
            type: "text",
            disabled: this.props.disabled,
            value: this.controller.selected.label,
            onClick: this.controller.onClick,
            readOnly: true,
            tabIndex: -1,
        };
        if (this.props.showPlaceHolder) {
            props.placeholder = this.props.placeholder;
        }
        return (React.createElement("input", Object.assign({}, props)));
    }
    renderFilter() {
        return (React.createElement("div", { className: "rj-drop-down__filter-container" },
            React.createElement("input", { className: "rj-drop-down__filter", type: "text", disabled: this.props.disabled, value: this.controller.filter, onChange: this.controller.onChange, onFocus: this.controller.onFocus, onBlur: this.controller.onBlur, "data-drop-down-keep": true, ref: this.html.filter })));
    }
    getRootClasses() {
        return `rj-drop-down${this.controller.isOpened ?
            " rj-drop-down--is-opened" : ""}${this.props.hasFilter ?
            " rj-drop-down--with-filter" : ""}`;
    }
    renderDropDownList() {
        const classesModifier = [];
        this.props.isNeededMaxZIndex && classesModifier.push("rj-drop-down-list--max-z-index");
        this.props.dropdownListClassModifier && classesModifier.push(this.props.dropdownListClassModifier);
        return (React.createElement(DropDownListWrapper, { classesModifier: classesModifier, hideHandler: this.controller.hideOptions, rootElement: this.html.rootElement, isPortalNeeded: this.props.isPortalNeeded },
            React.createElement("div", { className: "rj-drop-down__options" },
                React.createElement("div", { className: "rj-drop-down-scrollable", "data-drop-down-scrollable": true }, this.controller.resultData.map(o => {
                    const selected = o.value === this.controller.selected.value ? true : undefined;
                    return React.createElement("div", { key: o.value, className: "rj-drop-down__option", "data-value": o.value, "data-disabled": o.disabled, "data-selected": selected, onMouseDown: this.controller.onOptionClick }, o.label);
                })))));
    }
    renderNativeSelect() {
        return (React.createElement("select", { className: "rj-drop-down__native", "data-uat": "dropdown-native-select", name: this.props.id, id: this.props.id, disabled: this.props.disabled, value: this.controller.selected.value, onChange: this.controller.onSelectChange, onFocus: this.controller.onFocus, onBlur: this.controller.onBlur },
            this.props.showPlaceHolder && React.createElement("option", { key: -1, disabled: true, hidden: true, value: "" }, this.props.placeholder),
            this.props.data.map(o => (React.createElement("option", { key: o.value, value: o.value }, o.label)))));
    }
};
DropDown.defaultProps = {
    id: "",
    placeholder: "",
    data: [],
    showPlaceHolder: true,
    disabled: false,
    isNeededMaxZIndex: false,
    isPortalNeeded: true
};
DropDown = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DropDown);
export { DropDown };
//# sourceMappingURL=DropDown.js.map